import { pipe } from "fp-ts/lib/function";
import {
  ChecksumAddress,
  ProtocolKey,
  getChecksumAddressOrThrow,
} from "@silo/types";
import { array, option, record } from "fp-ts";
import { PROTOCOL_CONFIG } from "@silo/config";
import { Array } from "effect";

export const SILO_WHITELIST: Record<ProtocolKey, ChecksumAddress[]> = {
  mainnetLegacy: pipe(
    PROTOCOL_CONFIG.mainnetLegacy.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  mainnetLlama: pipe(
    PROTOCOL_CONFIG.mainnetLlama.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  mainnetGrand: pipe(
    PROTOCOL_CONFIG.mainnetGrand.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  local: pipe(
    PROTOCOL_CONFIG.local.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  arbitrum: pipe(
    PROTOCOL_CONFIG.arbitrum.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  optimism: pipe(
    PROTOCOL_CONFIG.optimism.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  base: pipe(
    PROTOCOL_CONFIG.base.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  lrtbase: pipe(
    PROTOCOL_CONFIG.lrtbase.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
  anvil: pipe(
    PROTOCOL_CONFIG.anvil.marketWhitelist,
    Array.fromIterable,
    Array.map(getChecksumAddressOrThrow)
  ),
};

/**
 * Returns an Option of a protocol key, that the given silo address is whitelisted for.
 * Option, because it's possible that the silo is not whitelisted for any protocol key.
 */
export function whitelistedForProtocolKey(
  siloAddress: ChecksumAddress
): option.Option<ProtocolKey> {
  return pipe(
    SILO_WHITELIST,
    record.toEntries,
    array.findFirst(
      ([, siloAddresses]) =>
        !!siloAddresses.find((address) => address === siloAddress)
    ),
    option.map(([protocolKey]) => protocolKey)
  );
}
